export class Product {
    id: number;
    name: string;
    shortDescription: string;
    description: string;
    price: string;
    videos: Array<any>;

    constructor(fetchedProduct: any) {
        this.id = fetchedProduct.id;
        this.name = fetchedProduct.name;
        this.shortDescription = fetchedProduct.short_description;
        this.description = fetchedProduct.description;
        this.videos = fetchedProduct.videos;
    }
}


// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/(IGH Projects)/jobs/EVFS PROD_FRONTEND granima.de/workspace/frontend/src/app/models/product.model.ts